import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import { resolveRefsInMarkdown } from "@/lib/coachRefs";

// Wraps ReactMarkdown so [grant:..]/[bill:..]/[article:..]/[funder:..] tokens
// become clickable in-app links. External links open in a new tab.
const CoachMarkdown = ({ children }: { children: string }) => {
  const resolved = resolveRefsInMarkdown(children ?? "");
  return (
    <ReactMarkdown
      components={{
        a: ({ href, children: kids, ...rest }) => {
          const url = href ?? "";
          const isInternal = url.startsWith("/");
          if (isInternal) {
            return (
              <Link to={url} className="text-primary hover:underline">
                {kids}
              </Link>
            );
          }
          return (
            <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" {...rest}>
              {kids}
            </a>
          );
        },
      }}
    >
      {resolved}
    </ReactMarkdown>
  );
};

export default CoachMarkdown;